// Curated comment marker palette. Muted, earthy tones tuned to the app's
// sand/forest/charcoal brand rather than a saturated rainbow — even saturation
// and lightness keep initials legible and the colors read as distinct from one
// another and from the darker tag-ring colors. Stored as #RRGGBB — the storage
// format is freeform-capable, so a custom picker can be layered on later
// without backend changes.
export const COMMENT_COLOR_PALETTE = [
    { hex: '#B65C4A', name: 'Terracotta' },
    { hex: '#C2904A', name: 'Ochre' },
    { hex: '#8A8B4C', name: 'Moss' },
    { hex: '#4E8C63', name: 'Fern' },
    { hex: '#3F8A86', name: 'Teal' },
    { hex: '#5878A6', name: 'Slate Blue' },
    { hex: '#8A6BA0', name: 'Plum' },
    { hex: '#B06A7E', name: 'Clay Rose' },
    { hex: '#6E7480', name: 'Stone' },
];
// Case-insensitive match of a stored value against the palette.
export const isPaletteColor = (hex) => !!hex && COMMENT_COLOR_PALETTE.some(s => s.hex.toLowerCase() === hex.toLowerCase());
